export const checkoutPopupSuccessMessage = {
  shippingAddressAdded: 'Shipping address added successfully!',
  billingAddressAdded: 'Billing address added successfully!',
  newAddressAdded: 'New Address added successfully!',
  updateAddress: 'Updated Address successfully!',
  removedAddress: 'Address has been removed successfully!',
  promoCodeAdded: 'Successfully added promo code!',
  couponCodeAdded: 'Successfully added coupon code!',
  promoCodeRemoved: 'Removed promo code!',
  referCodeAdded: 'Successfully added refer code!',
  referCodeRemoved: 'Removed refer code!',
  invalidPromoCode: 'Sorry, invalid code!',
  mismatchCouponCondition:
    'The selected coupon does not match the coupon conditions',
  alreadyUsedOrInvalidCoupon:
    'The selected coupon is either has already been used or invalid.',
  shippingAddressRequired: 'Add shipping address to continue.',
  paymentMethodRequired: 'Select payment method to continue.',
  shippingAndPaymentMethodRequired:
    'Add shipping address and payment method to continue.',
  shippingMethodRequired: 'Shipping method is required',
};

export const comparisonPopupMessages = {
  removedList:
    'You can compare up to 3 products. Please remove one to add another.',
  clearList: 'All the products have been removed from the comparison table.',
};

export const ratingPopupMessages = {
  failed: 'Rating submission failed! Please try again.',
  success: 'Thank you! Your rating has been received and is being processed.',
};

export const spinTheWheelMessages = {
  alreadyWonCouponDesc: 'You have already won a coupon.',
  successfullyCopiedCoupon: 'Coupon copied to clipboard!',
  somethingWentWrong:
    'We’re sorry—an unexpected error occurred. Please try again in a moment. If the problem persists, contact our support team for assistance.',
  errorStaticTitle: 'Something Went Wrong',
};

// default meta data for home page
export const homepageMetaData = {
  desc: 'Singer Bangladesh Limited is operating in Bangladesh for 100 Years. Singer promises world class Electronic & Home Appliances at affordable price.',
  keyWord:
    'Refrigerator, Washing machine, LED, Smart TV, Deep Fridge, Freezer, Microwave oven, Kitchen, Home Appliance,small Appliance,Electronics, Laptops brands, Air conditioners, AC, HP, Dell, Laptop, Computer, price in bangladesh, Singer Bangladesh, Beko, best brands, online, price, in BD, in Dhaka, in Bangladesh,2025',
};
